var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{ref:"text",staticClass:"text-highlight"},[_vm._l((_vm.linesNumber),function(line,index){return _c('text-line',{key:index,ref:"lines",refInFor:true,style:({ height: _vm.lineLineHeight, top: index*parseInt(_vm.lineLineHeight, 10) + 'px' })})}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.textHtml)}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6de3dad8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TextHighlightAnimation/TextHighlight.vue
// module id = null
// module chunks = 